export default pID => {
    let $pID = $('.pID');

    if (! $pID.length) {
        return false;
    }

    $pID.on('click', function() {
        let JSON = {
            paolaLocationId: $(this).data('paola-location-id'),
            paolaLocationName: $(this).data('paola-location-name'),
            zipCode: $(this).data('zip-code'),
            city: $(this).data('city')
        };

        $.ajax({
            url: "ajax/paola-location",
            data: JSON,
            xhrFields: {
                withCredentials: true
            }
        }).done(function(data) {
            if(data.status === 'OK') {
                location.reload();
            }
        });
    });
};
